import { LogEntryCombinedProps } from './types';

const usePresenter = (props: LogEntryCombinedProps): LogEntryCombinedProps => {
  return props;
};

export default usePresenter;
